import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Validator',
    entityNamePlural: 'Validators',
    entityNameModule: 'settings',
  }), [])
}
